export default "__VITE_ASSET__C6ggHflz__"